import { Injectable } from '@angular/core';
/** Default dropdown configuration */
export var BsDropdownConfig = (function () {
    function BsDropdownConfig() {
        /** default dropdown auto closing behavior */
        this.autoClose = true;
    }
    BsDropdownConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    BsDropdownConfig.ctorParameters = function () { return []; };
    return BsDropdownConfig;
}());
//# sourceMappingURL=bs-dropdown.config.js.map


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/ngx-bootstrap/dropdown/bs-dropdown.config.js
// module id = ../../../../ngx-bootstrap/dropdown/bs-dropdown.config.js
// module chunks = 4